(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/settings/appearance', {
      templateUrl: 'modules/app/settings/appearance/appearance.html',
      controller: 'AppearanceSettingsCtrl',
      requiredPermissions: ['admin', 'manager']
    });
  }]).controller('AppearanceSettingsCtrl', ['$scope', "Utils", function ($scope) {
    $scope.$emit("headline:change", "Settings");
    $scope.$emit("nav:change", "settings");
    $scope.section = "appearance";
  }]).controller('OrganizationDisplayCtrl', ['$scope', '$controller', '$uibModal', '$http', 'Api', 'User', 'Validation', '$q', 'UserRoles', 'OrganizationSettings', function ($scope, $controller, $uibModal, $http, Api, User, Validation, $q, UserRoles, OrganizationSettings) {
    var user = User.get();
    var orgId = user.organization.id;
    $scope.showCustomLess = UserRoles.isOrgAdmin(user);

    //Get current organization info
    $http.get(Api.url("/organizations/" + orgId, true)).then(function getOrganizationSuccess(response) {
      $scope.organization = response.data;
      resetEditingState();
    });
    $scope.colors = OrganizationSettings.getSettingsSync().colors;
    // Doing this so that the placeholder will be visible for people setting colors for the first time.
    // The placeholder just tells them to create a comma-separated list of colors
    $scope.colorCopy = $scope.colors && $scope.colors.length ? JSON.stringify(angular.copy($scope.colors)) : '';

    //set these two properties to be used by uploadImageModal
    $scope.uploadUrl = '/images';
    $scope.isOrgLogoImage = true;
    $scope.showUploadImageModal = function () {
      $scope.uploadImageModal = $uibModal.open({
        templateUrl: "modules/common/images/upload-image-modal.html",
        controller: "UploadImageCtrl",
        backdrop: 'static',
        scope: $scope
      });

      // The modal "resolves" to (closes with) image url
      $scope.uploadImageModal.result.then(function (imageUrl) {
        $scope.editCopy.imageUrl = imageUrl;
        $scope.saveOrganization();
      });
    };

    //delete image url from organization
    $scope.clearImage = function () {
      $scope.editCopy.imageUrl = null;
      $scope.saveOrganization();
    };

    //set these two properties to be used by uploadImageModal
    $scope.uploadFileUrl = '/css';
    $scope.showUploadLessModal = function () {
      $scope.uploadFileModal = $uibModal.open({
        templateUrl: "modules/common/file/file-upload-modal.html",
        controller: "FileUploadCtrl",
        backdrop: 'static',
        scope: $scope
      });
    };

    //delete less url from organization
    $scope.clearLess = function () {
      $http.delete(Api.url('/css'));
      $scope.editCopy.lessUrl = null;
      $scope.saveOrganization();
    };

    //save organization information
    $scope.saveOrganization = function () {
      $scope.formErrors = Validation.validate({
        "name": {
          "rules": {
            "required": true
          },
          "value": $scope.editCopy.name
        }
      });
      if ($scope.formErrors !== null) {
        return;
      }
      $scope.saving = true;
      var orgSave = $http.put(Api.url("/organizations/" + $scope.editCopy.id, true), $scope.editCopy).then(function saveOrganizationSuccess() {}, function saveOrganizationError(response) {
        return $q.reject("Error saving organization " + $scope.editCopy.id + ", response status " + response.status);
      });
      orgSave = orgSave.then(function () {
        $scope.organization = angular.copy($scope.editCopy);
        resetEditingState();
        updateOrganizationInScope();
      }, function (reason) {
        $scope.saveError = "There was an error saving the organization";
        if (reason) {
          $scope.saveError = $scope.saveError + " " + reason;
        }
      });
    };
    function resetEditingState() {
      $scope.editCopy = angular.copy($scope.organization);
      $scope.saving = false;
      $scope.editing = false;
      $scope.formErrors = null;
      $scope.saveError = null;
    }

    //this is so that logo and subheadline will update automatically when user changes info
    function updateOrganizationInScope() {
      var user = User.get();
      user.membership.organziation = $scope.organization;
      user.organization = $scope.organization;
      User.set(user);
      $scope.$emit("headline:change", "Settings");
    }
    $scope.resetEditingState = resetEditingState;
    $controller('UploadImageCtrl', {
      $scope: $scope
    });
    $scope.saveColors = function saveColors() {
      $scope.savingColors = true;
      if (typeof $scope.colorCopy === "string") {
        try {
          //remove leading and trailing whitespace and [ ]
          $scope.colorCopy = $scope.colorCopy.trim();
          $scope.colorCopy = $scope.colorCopy.replace(/(^\[|\]$)/g, "");

          //split on comma except if it's inside parenthesis
          var colors = $scope.colorCopy.split(/\s*,\s*(?![^(]*\))/);

          //make sure all colors are quoted and filter out blank strings
          colors = _.chain(colors).filter(function (c) {
            return c.length;
          }).map(function (c) {
            if (!c.startsWith("\"")) {
              c = "\"" + c;
            }
            if (!c.endsWith("\"")) {
              c = c + "\"";
            }
            return c;
          }).value();

          //join the colors with commas and add [ and ]
          $scope.colorCopy = colors.join(",");
          $scope.colorCopy = "[" + $scope.colorCopy + "]";
          $scope.colorCopy = JSON.parse($scope.colorCopy);
        } catch (jsonExp) {
          $scope.colorFormError = "There was an error parsing this input.<br/>" + "Please provide a list of quoted colors.<br/>Example: [\"#FF0000\", \"#0000FF\"]";
          $scope.savingColors = false;
          return;
        }
      }

      // If they deleted everything, just save an empty array. Server doesn't like trying to save "undefined"
      if (!$scope.colorCopy) {
        $scope.colorCopy = [];
      }
      $http.put(Api.url("/settings/colors"), $scope.colorCopy).then(function () {
        $scope.colors = angular.copy($scope.colorCopy);
        $scope.resetColorState();
        OrganizationSettings.getSettingsSync().colors = angular.copy($scope.colors);
        //todo: update in scope settings
      }, function (r) {
        $scope.colorFormErrors = r;
      });
    };
    $scope.resetColorState = function resetColorState() {
      if (typeof $scope.colors === "string") {
        $scope.colors = JSON.parse($scope.colors);
      }
      $scope.colorCopy = JSON.stringify(angular.copy($scope.colors));
      $scope.editingColors = false;
      $scope.savingColors = false;
      $scope.colorFormError = null;
    };
  }]);
})();
